import React, { Component } from 'react';
// import { getChildren } from '../../utils/constant';

// const getConfig = (props) => {
//   const { background = 'inherit', color = '#fff', movieList } = props;
//   // title, imgUrl, cid, vid, color
//   const config = [
//     {
//       name: "Container",
//       props: {
//         width: '95%',
//         padding: '10px 0 2px',
//         background,
//         color: color,
//       },
//       children: [
//         {
//           name: "Container",
//           props: {
//             width: '95%',
//           },
//           children: [
            
//           ]
//         }
//       ]
//     },
//   ];
//   for (let i = 0; i < movieList.length; i++) {
//     const movieConfig = {
//       name: "ThreeImgInVt",
//       props: { movieList: movieList[i] }
//     }

//     config[0].children[0].children.push(movieConfig);
//   }
//   return config;
// }


export class MovieContainer extends Component {

  render() {
    const { style, ...restProps } = this.props;
    const customAttributes = {
    };
    return (
      <div {...customAttributes} style={style} {...restProps}>{this.props.children}</div>
    );
  }
}

export default MovieContainer;
